<!--
 * @Descripttion: 首页组件
 * @Author: congz
 * @Date: 2020-06-04 11:22:40
 * @LastEditors: congz
 * @LastEditTime: 2020-08-12 21:20:08
--> 

<template>
  <div class="home" id="home" name="home">
    <!-- Hero Section -->
    <div class="hero">
      <div class="hero-banner" :style="{ backgroundImage: `url(${currentHeroImage})` }">
        <div class="hero-overlay">
          <div class="hero-title">Built For Big Imaginations.</div>
          <div class="hero-desc">
            Toy cars, building sets, ride-ons, STEM kits and wooden playsets — age-graded for the way kids actually play. Safe materials, honest prices and doorstep delivery across India.
          </div>
          <router-link class="hero-btn" to="/goods">Shop Now</router-link>
        </div>
        <div class="hero-dots">
          <span
            v-for="(img, idx) in heroImages"
            :key="idx"
            class="hero-dot"
            :class="{ active: heroIndex === idx }"
            @click="setHeroIndex(idx)"
          ></span>
        </div>
      </div>
    </div>

    <!-- Category Products Section -->
    <div class="main-box">
      <div class="main">
        <div class="section-header">
          <h2>New Arrivals</h2>
          <p>Fresh toys &amp; games just landed</p>
        </div>
        <div class="category-products">
          <ProductGrid :list="homeProducts" :isMore="false"></ProductGrid>
        </div>

        <!-- Why Shop With Us -->
        <div class="why-section">
          <div class="why-item">
            <div class="why-icon">🚚</div>
            <h3>Free Shipping</h3>
            <p>On orders above ₹499</p>
          </div>
          <div class="why-item">
            <div class="why-icon">🧸</div>
            <h3>Kid-Safe Materials</h3>
            <p>Non-toxic, age-graded &amp; BIS-tested</p>
          </div>
          <div class="why-item">
            <div class="why-icon">🔄</div>
            <h3>Easy Returns</h3>
            <p>7-day hassle-free returns</p>
          </div>
          <div class="why-item">
            <div class="why-icon">💳</div>
            <h3>Secure Payment</h3>
            <p>UPI, COD &amp; cards accepted</p>
          </div>
        </div>

        <!-- Shop By Category Tiles -->
        <div class="home-section cat-section">
          <div class="home-section-header">
            <div>
              <h2>Shop By Category</h2>
              <p>Twelve aisles, endless play</p>
            </div>
            <router-link class="section-cta" to="/goods">See All</router-link>
          </div>
          <div class="cat-tiles">
            <router-link
              v-for="tile in categoryTiles"
              :key="tile.id"
              class="cat-tile"
              :to="`/goods?categoryID=${tile.id}`"
            >
              <span class="cat-tile-accent"></span>
              <img :src="tile.img" :alt="tile.name" loading="lazy" />
              <span class="cat-tile-label">{{ tile.name }}</span>
            </router-link>
          </div>
        </div>

        <!-- Discover Section -->
        <div class="home-section">
          <div class="home-section-header">
            <div>
              <h2>Shop The Edit</h2>
              <p>From RC cars to STEM kits — pick a shelf</p>
            </div>
            <div class="section-tabs">
              <span
                v-for="tab in discoverTabs"
                :key="tab.key"
                class="tab-item"
                :class="{active: discoverActive===tab.key}"
                @click="discoverActive=tab.key"
              >{{ tab.label }}</span>
            </div>
          </div>
          <ProductGrid :list="discoverProducts" :isMore="false"></ProductGrid>
          <router-link class="section-cta" to="/goods">See More</router-link>
        </div>

        <!-- Full Width Promo Banner -->
        <div class="promo-full-banner">
          <div class="promo-content">
            <span class="promo-tag">Limited Time Offer</span>
            <h2>THE BUILD &amp; PLAY EDIT</h2>
            <p>Up to 30% Off on Building Sets, STEM Kits &amp; Pretend Play</p>
            <router-link class="promo-btn" to="/goods">Shop Now</router-link>
          </div>
          <div class="promo-image">
            <img src="https://india-shop.oss-ap-southeast-1.aliyuncs.com/shop7/7000716/img_00.webp" alt="Play Panda Fixi Bricks Aqua Tube 3 Building Block Set" />
          </div>
        </div>

        <!-- Split Banners -->
        <div class="split-banners-grid">
          <div class="split-banner">
            <div class="split-content">
              <div class="split-title">Learning That Feels Like Play</div>
              <div class="split-desc">
                Puzzles, spelling games and early-learning kits that quietly build focus, vocabulary and problem solving — without a screen in sight.
              </div>
              <router-link class="section-cta" to="/goods?categoryID=327">Explore Now</router-link>
            </div>
            <div class="split-image">
               <img src="https://india-shop.oss-ap-southeast-1.aliyuncs.com/shop7/7001150/img_00.jpg" alt="Toybox by Ratna Mind Puzzler Level 2" />
            </div>
          </div>
          <div class="split-banner">
            <div class="split-content">
              <div class="split-title">Ride Into Playtime</div>
              <div class="split-desc">
                Battery ride-ons, push scooters and pedal cars sized for little legs — the toys they ask for every single evening.
              </div>
              <router-link class="section-cta" to="/goods?categoryID=326">Explore Now</router-link>
            </div>
            <div class="split-image">
               <img src="https://india-shop.oss-ap-southeast-1.aliyuncs.com/shop7/7001027/img_00.png" alt="Battery Harley Ride-On Bike" />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import * as productsAPI from '@/api/products/'
import * as categoryAPI from '@/api/categories/'
import ProductGrid from '@/components/ProductGrid'

export default {
  components: { ProductGrid },
  data() {
    return {
      carousels: [], // 轮播图数据（后端接口，已忽略：Hero 由下方精选玩具图池提供）
      // Discover 区：8 个玩具分类 tab（category_id 对应 sql/玩具.sql 的 category_id 320-331）
      discoverTabs: [
        { key: 'CARS', id: 320, label: 'TOY CARS' },
        { key: 'DIECAST', id: 321, label: 'DIECAST' },
        { key: 'OUTDOOR', id: 325, label: 'OUTDOOR' },
        { key: 'ROLEPLAY', id: 322, label: 'ROLE PLAY' },
        { key: 'STEM', id: 327, label: 'STEM' },
        { key: 'GAMES', id: 328, label: 'INDOOR GAMES' },
        { key: 'LICENSED', id: 331, label: 'LICENSED' },
        { key: 'PLAYSETS', id: 330, label: 'PLAYSETS' }
      ],
      discoverActive: 'CARS', // Discover section active tab
      discoverLists: {}, // key -> 商品列表
      // Shop By Category 分类卡片（12 张，来自 sql/玩具.sql img_path，OSS shop7 路径）
      categoryTiles: [
        { id: 320, name: 'Toy Cars & Vehicles', img: 'https://india-shop.oss-ap-southeast-1.aliyuncs.com/shop7/7000191/img_00.png' },
        { id: 321, name: 'Licensed Diecast', img: 'https://india-shop.oss-ap-southeast-1.aliyuncs.com/shop7/7000412/img_00.png' },
        { id: 322, name: 'Pretend & Role Play', img: 'https://india-shop.oss-ap-southeast-1.aliyuncs.com/shop7/7000555/img_00.png' },
        { id: 323, name: 'Blocks & Building Sets', img: 'https://india-shop.oss-ap-southeast-1.aliyuncs.com/shop7/7000707/img_00.webp' },
        { id: 324, name: 'Trending Toys', img: 'https://india-shop.oss-ap-southeast-1.aliyuncs.com/shop7/7000771/img_00.png' },
        { id: 325, name: 'Outdoor & Sports', img: 'https://india-shop.oss-ap-southeast-1.aliyuncs.com/shop7/7000916/img_00.jpg' },
        { id: 326, name: 'Ride-On Toys', img: 'https://india-shop.oss-ap-southeast-1.aliyuncs.com/shop7/7001048/img_00.jpg' },
        { id: 327, name: 'Learning & STEM', img: 'https://india-shop.oss-ap-southeast-1.aliyuncs.com/shop7/7001058/img_00.jpg' },
        { id: 328, name: 'Action & Indoor Games', img: 'https://india-shop.oss-ap-southeast-1.aliyuncs.com/shop7/7001295/img_00.png' },
        { id: 329, name: 'Wooden Toys & Playsets', img: 'https://india-shop.oss-ap-southeast-1.aliyuncs.com/shop7/7001425/img_00.jpg' },
        { id: 330, name: 'Big Playsets', img: 'https://india-shop.oss-ap-southeast-1.aliyuncs.com/shop7/7001445/img_00.jpg' },
        { id: 331, name: 'Licensed Toys & Sets', img: 'https://india-shop.oss-ap-southeast-1.aliyuncs.com/shop7/7001634/img_00.png' }
      ],
      // Hero 轮播：精选玩具图池（OSS shop7 路径，来自 sql/玩具.sql img_path，与 abtostyle.in 不重复）
      heroImages: [
        'https://india-shop.oss-ap-southeast-1.aliyuncs.com/shop7/7001416/img_00.jpg', // Playbox Wooden Cashier Playset
        'https://india-shop.oss-ap-southeast-1.aliyuncs.com/shop7/7000530/img_00.jpg', // Barbie Doll in Blue Logo Dress
        'https://india-shop.oss-ap-southeast-1.aliyuncs.com/shop7/7000606/img_00.jpg', // Marvel Thor Mjolnir Role Play Hammer
        'https://india-shop.oss-ap-southeast-1.aliyuncs.com/shop7/7001486/img_00.jpg'  // STEP2 Fiesta Cruise Water Table
      ],
      heroIndex: 0,
      heroTimer: null,
      start: 0,
      limit: 7,
      homeCategories: [],
      activeCategoryId: 0,
      homeProducts: [],
      homeStart: 0,
      homeLimit: 8
    }
  },
  computed: {
    currentHeroImage() {
      // 直接使用精选玩具图池，忽略后端 carousels
      return this.heroImages[this.heroIndex] || this.heroImages[0]
    },
    discoverProducts() {
      return this.discoverLists[this.discoverActive] || []
    }
  },
  activated() {
    // 获取首页数据
    this.load()
    this.startHeroRotation()
  },
  deactivated() {
    this.stopHeroRotation()
  },
  beforeDestroy() {
    this.stopHeroRotation()
  },
  methods: {
    // Hero 轮播控制
    setHeroIndex(idx) {
      this.heroIndex = idx
    },
    startHeroRotation() {
      this.stopHeroRotation()
      if (!this.heroImages || this.heroImages.length < 2) return
      this.heroTimer = setInterval(() => {
        this.heroIndex = (this.heroIndex + 1) % this.heroImages.length
      }, 5000)
    },
    stopHeroRotation() {
      if (this.heroTimer) {
        clearInterval(this.heroTimer)
        this.heroTimer = null
      }
    },
    load() {
      // 不再请求后端 carousels 接口。Hero 轮播由精选玩具图池提供。
      // 首页类目：取导航“Shop Now”同源分类
      categoryAPI
        .listCategories()
        .then(res => {
          if (res.status === 200) {
            const list = Array.isArray(res.data) ? res.data : []
            this.homeCategories = [{ category_id: 0, category_name: 'All' }, ...list]
            this.activeCategoryId = 0
            this.fetchHomeProducts(0)
          } else {
            this.notifyError('Failed to obtain classification', res.msg)
          }
        })
        .catch(err => {
          this.notifyError('Failed to obtain classification', err)
        })
      // Discover section: 8 个玩具分类（类别 id 直接用 category_id 320-331）
      this.loadDiscover()
    },
    // Discover 区：按 8 个 tab 拉取商品
    loadDiscover() {
      this.discoverTabs.forEach(tab => {
        productsAPI
          .listProducts(tab.id, 0, this.limit)
          .then(res => {
            if (res.status === 200) {
              this.$set(this.discoverLists, tab.key, this.shuffle((res.data && res.data.items) || []))
            }
          })
          .catch(() => {})
      })
    },
    fetchHomeProducts(categoryId) {
      productsAPI
        .listProducts(categoryId, this.homeStart, this.homeLimit)
        .then(res => {
          if (res.status === 200) {
            this.homeProducts = this.shuffle(Array.isArray(res.data.items) ? res.data.items : [])
          } else {
            this.notifyError('Failed', res.msg)
          }
        })
        .catch(err => {
          this.notifyError('Failed', err)
        })
    },
    // Fisher-Yates shuffle
    shuffle(array) {
      const arr = [...array]
      for (let i = arr.length - 1; i > 0; i--) {
        const j = Math.floor(Math.random() * (i + 1))
        ;[arr[i], arr[j]] = [arr[j], arr[i]]
      }
      return arr
    }
  },
  beforeRouteEnter(to, from, next) {
    // 添加背景色
    document
      .querySelector('body')
      .setAttribute('style', 'background-color:#FFFFFF')
    next()
  },
  beforeRouteLeave(to, from, next) {
    // 去除背景色
    document
      .querySelector('body')
      .setAttribute('style', 'background-color:#FFFFFF')
    next()
  }
}
</script>
<style scoped>
@import '../assets/css/index.css';

/* Shop By Category Tiles（SWIFTCART · 玩具） */
.cat-section .cat-tiles {
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  gap: 16px;
  margin: 8px 0 44px;
}
.cat-section .cat-tile {
  position: relative;
  display: block;
  border-radius: 14px;
  overflow: hidden;
  background: #f7fbff;
  text-decoration: none;
}
.cat-section .cat-tile img {
  width: 100%;
  height: 230px;
  object-fit: cover;
  display: block;
  transition: transform 0.35s ease;
}
.cat-section .cat-tile:hover img {
  transform: scale(1.05);
}
.cat-section .cat-tile-accent {
  position: absolute;
  top: 10px;
  left: 10px;
  z-index: 2;
  width: 36px;
  height: 4px;
  border-radius: 2px;
  background: #38bdf8;
}
.cat-section .cat-tile-label {
  position: absolute;
  left: 0;
  right: 0;
  bottom: 0;
  padding: 22px 14px 12px;
  background: linear-gradient(180deg, rgba(11,107,230, 0) 0%, rgba(11,107,230, 0.85) 100%);
  color: #FFFFFF;
  font-size: 13px;
  font-weight: 700;
  letter-spacing: 1px;
  text-transform: uppercase;
}
@media (max-width: 900px) {
  .cat-section .cat-tiles {
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: 12px;
  }
  .cat-section .cat-tile img {
    height: 160px;
  }
}
</style>
